import { ModuleIsEnabledFilter } from '@gongxigames/framework/core';
import { FlowModuleEvents } from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import {
    isEnabledPromotionType,
    MultiSetsMulticampaignPromotionLogic,
    MultiSetsMulticampaignPromotionStatesMap,
    MultiSetsMulticampaignPromotionStates,
    PromotionTypes,
    BasePromotionModule,
} from '@gongxigames/framework/promotions';

export type MultiSetsMulticampaignPromotionModuleEvents = {
    'MultiSetsMulticampaignPromotion.START_STATE_LEFT': void;
} & GlobalEventsMapForBackwardCompatibility;

export class MultiSetsMulticampaignPromotionModule extends BasePromotionModule<MultiSetsMulticampaignPromotionModuleEvents> {
    public static readonly NAME: symbol = Symbol.for('MultiSetsMulticampaignPromotionModule');
    public static readonly isEnabled: ModuleIsEnabledFilter = isEnabledPromotionType(PromotionTypes.MultiSetsMulticampaignPromotion);

    public shouldEndPromotion(): boolean {
        return !this.getPromotion().isActive() || this.getPromotion().isLastPromotion();
    }

    public shouldTerminatePromotion(): boolean {
        return this.getPromotion().isExpired();
    }

    protected setupStates(): void {
        this.addStates(MultiSetsMulticampaignPromotionStatesMap);
        this.gotoState(MultiSetsMulticampaignPromotionStates.INIT);
    }

    protected setupEvents(): void {
        super.setupEvents();

        this.onCurrentStateHandle(FlowModuleEvents.FEATURE_STARTED);
    }

    public endPromotion(): void {
        this.getPromotion<MultiSetsMulticampaignPromotionLogic>().end();
        this.getEventManager<GlobalEventsMapForBackwardCompatibility>().emit('General.Promotion.Campaign.Ended');

        // check for next promotion first to avoid error from getData in case of no promotion
        if (!this.getPromotion().hasPromotion() || this.getPromotion().getData().type === 'free-round') {
            this.emitShowBetPanel();
        }
        
        if (this.getPromotion().hasPromotion()) {
            this.gotoState(MultiSetsMulticampaignPromotionStates.START);
        } else {
            this.gotoState(MultiSetsMulticampaignPromotionStates.BASIC);
            this.getEventManager<GlobalEventsMapForBackwardCompatibility>().emit('General.Promotion.Ended');
        }
    }
}
